export class Customer {
    customerId:string;
    title:string;
    description?:string;
    website?:string;
    address1?:string;
    address2?:string;
    zip?:string;
    city?:string;
    main_contact?:string;
    creator:string;
    created:string;
    versioncreator:string;
    validfrom:string;
    validto:string;
    organizationId:string;
    numberofdeals?:number;
}